import * as yup from 'yup';

export const requiredTxt = 'Field is required';
export const validationSchema = yup.object().shape({
  websiteUrl: yup.string().trim().url().required(requiredTxt),
  propertyName: yup.string().trim().required(requiredTxt),
  email: yup.string().trim().email('Must be a valid email').required(requiredTxt),
  propertyType: yup.string().trim().required(requiredTxt),
  propertyAddress: yup.string().trim().required(requiredTxt),
  fullName: yup.string().trim().required(requiredTxt),
  phone: yup
    .string()
    .trim()
    .matches(/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/, {
      message: 'Invalid phone number',
      excludeEmptyString: false,
    })
    .required(requiredTxt),
  company: yup.string().trim().required(requiredTxt),
});
